import Small from 'UIComponents/elements/Small';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EPSpotlightCategory = ({
  category,
  children
}) => {
  return /*#__PURE__*/_jsxs("div", {
    className: "m-top-4",
    children: [/*#__PURE__*/_jsx(Small, {
      style: {
        fontWeight: 500
      },
      className: "p-x-4 p-bottom-2 display-block",
      children: category
    }), /*#__PURE__*/_jsx("ul", {
      className: "p-x-0",
      children: children
    })]
  });
};
export default EPSpotlightCategory;